import React, { Component } from 'react';
import {ExcelExport, ExcelExportColumn} from "@progress/kendo-react-excel-export";
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import moment from 'moment';
import IconButton from "./IconButton"

@observer
export default class ExportarDadosExcel extends Component {

    constructor(props) {
        super(props)

        this.controller = this.props.controller
    }

    _exporter;
    export = () => {
        this._exporter.save();
    };

    render() {
        let desabilita = this.props.desabilita ? this.props.desabilita : false;
        let lista = toJS(this.props.lista);
        const colunas = this.props.colunas;

        if (lista.length > 0)
        {
            lista.map(data => {
                const keys = Object.keys(data);
                keys.map(key =>{
                    colunas.map((c,x) =>{
                        if (c.dataField === key && c.campoData && moment(data[key]).format("DD/MM/YYYY HH:mm") !== 'Invalid date')
                        {
                            data[key] = moment(data[key]).format("DD/MM/YYYY HH:mm");
                        } else if (c.dataField === key && c.type==="string")
                        {
                            data[key] = data[key].toString();
                        }
                    });
                })
            })
        }
        return (
            <div>
                <IconButton 
                    icon="file-excel"
                    text={this.props.buttonText ? this.props.buttonText : "Baixar XLS"}
                    size="md"
                    onClick={!desabilita ? this.export : () => {}}
                />
                <ExcelExport
                    data={lista}
                    fileName={this.props.filename}
                    ref={(exporter) => { this._exporter = exporter; }} >
                    { colunas.map((coluna, index) => (
                        <ExcelExportColumn
                            key={index}
                            title={coluna.text}
                            field={coluna.dataField}
                        />
                    )) }
                </ExcelExport>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/ExportarDadosExcel.js